import { writable } from 'svelte/store';

let state = {
    messages: [],
};

let message = () => {
    const { subscribe, set, update } = writable(state);

    return {
        subscribe,
        push: message => {
            return update((store) => ({
                ...store,
                messages: [
                    ...store.messages,
                    message
                ],
            }));
        },
        set: messages => {
            return update((store) => ({
                ...store,
                messages,
            }));
        },
        updateAt: (idx, message) => {
            return update((store) => {
                store.messages[idx] = message
                return store
            });
        },
    };
};

export default message();
